import {Cards} from '/constant/TestIDs';

import {DashboardMetricCardsProps} from './DashboardMetricCards.types';

export const generateCards = ({
  frontLineCoachMetrics,
  gen0CoachMetrics,
  isBusinessLeader,
  isBusinessLeaderOrBusinessCoach,
  totalGenerationVolumeMetrics,
  tt,
  ts,
}: DashboardMetricCardsProps) => {
  const cards = [
    {
      ...frontLineCoachMetrics,
      analyticsHeading: 'Frontline Qualifying Volume',
      heading: tt('carousel.fqv.title', 'Frontline Qualifying Volume'),
      infoAccessibilityLabel: ts(
        'carousel.fqv.accessibilityLabel',
        'Frontline Qualifying Volume information',
      ),
      infoPopOverHeading: tt('info.fqv', 'Frontline Qualifying Volume'),
      infoPopOverBody: tt(
        'info.fqv.body',
        'Sum of Personal Qualifying Volume (PQV) on orders from personally-sponsored (frontline) Clients and Coaches in a monthly bonus period. Frontline Qualifying Volume (FQV) does not include a Coach’s personal order.',
      ),
      testID: Cards.FQVCard,
    },
  ];

  if (isBusinessLeaderOrBusinessCoach) {
    cards.push({
      ...gen0CoachMetrics,
      analyticsHeading: 'Generation 0 Volume',
      heading: tt('carousel.gen0.title', 'Generation 0 Volume'),
      infoAccessibilityLabel: ts(
        'carousel.gen0.accessibilityLabel',
        'Generation 0 Volume information',
      ),
      infoPopOverHeading: tt('info.gen0.heading', 'Generation Zero Volume'),
      infoPopOverBody: tt(
        'info.gen0.body',
        'Sum of PQV on orders from Clients/Coaches in your Generation Zero (Gen 0), in a monthly bonus period. Gen 0 is all Clients and Coaches (personally sponsored by you or a Coach on your team), down to the first Executive Director or higher.',
      ),
      testID: Cards.G0VCard,
    });
  }

  if (isBusinessLeader) {
    cards.push({
      ...totalGenerationVolumeMetrics,
      analyticsHeading: 'Total Generation Volume',
      heading: tt('carousel.totalGen.title', 'Total Generation Volume'),
      infoAccessibilityLabel: ts(
        'carousel.totalGen.accessibilityLabel',
        'Total Generation Volume information',
      ),
      infoPopOverHeading: tt(
        'info.totalGen.heading',
        'Total Generation Volume',
      ),
      infoPopOverBody: tt(
        'info.totalGen.body',
        'Sum of PQV on orders from Clients/Coaches in your total applicable Generations, in a monthly bonus period. Each Generation consists of all Clients/ Coaches (personally sponsored by you or a Coach on your team), down to each ED or higher',
      ),
      testID: Cards.TGVCard,
    });
  }

  return cards;
};
